import { isAxiosError } from 'axios'

const SOURCE_GROUP_REFERENCE = 'SOURCE_GROUP_REFERENCE'

type BoomErrorPayload = {
  message?: string
}

export function isSourceGroupReferenceConflict(error: unknown): boolean {
  if (!isAxiosError(error)) {
    return false
  }

  const data = error.response?.data as BoomErrorPayload | undefined
  return (
    error.response?.status === 409 && data?.message === SOURCE_GROUP_REFERENCE
  )
}

/** At least 1 when the API reports a source group reference conflict (cached list may be stale). */
export function blockedSourceGroupCount(cachedCount: number | undefined): number {
  return Math.max(cachedCount ?? 0, 1)
}
